/**
 * @module modules/cid
 *
 * Functions for working with CommitNumer's, aka Commit IDs.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "lookupCids", {
    enumerable: true,
    get: function() {
        return lookupCids;
    }
});
const _jsonOrThrow = require("../../../infra-sk/modules/jsonOrThrow");
const lookupCids = (cids)=>fetch('/_/cid/', {
        method: 'POST',
        body: JSON.stringify(cids),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(_jsonOrThrow.jsonOrThrow);
